import { Status, StatusIndicator, StatusLabel } from "./ui/status-indicator";
import "./status-indicator-row.css";

export const StatusIndicatorRow = () => {
	return (
		<div className="r2-status-indicator-row">
			<Status
				className="r2-status-indicator-row__status r2-status-indicator-row__status--online"
				status="online"
				variant="outline"
			>
				<StatusIndicator />
				<StatusLabel>Active</StatusLabel>
			</Status>
			<Status
				className="r2-status-indicator-row__status r2-status-indicator-row__status--offline"
				status="offline"
				variant="outline"
			>
				<StatusIndicator />
				<StatusLabel>Suspended</StatusLabel>
			</Status>
			<Status
				className="r2-status-indicator-row__status r2-status-indicator-row__status--degraded"
				status="degraded"
				variant="outline"
			>
				<StatusIndicator />
				<StatusLabel>Provisional</StatusLabel>
			</Status>
		</div>
	);
};
